import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { PdfQuestionnaireFilled } from "Components/PdfQuestionnaire/PdfQuestionnaireFilled";
import { PdfTemplatePage } from "Components/PdfTemplate/PdfTemplatePage";
import { useParams } from "react-router-dom";

export const PdfTemplateQuestionnairePage = () => {
  const { analysisId, versionId } = useParams() as {
    analysisId: string;
    versionId: string;
  };

  return (
    <AnalysisDetailContext.Provider value={{ analysisId, versionId, readOnly: true, canAddFamilyMember: false }}>
      <PdfTemplatePage>
        <PdfQuestionnaireFilled />
      </PdfTemplatePage>
    </AnalysisDetailContext.Provider>
  );
};
